import { createSelector } from 'reselect';
import { Map } from 'immutable';
import moment from 'moment';

const filtersSelector = state => state.get('globalFilters').get('filters');

const selectedSelector = state => state.get('globalFilters').get('selected');

export const searchInputValueSelector = state => state.get('globalFilters').get('searchInputValue');

export const selectedFiltersSelector = createSelector(
  filtersSelector,
  selectedSelector,
  (filters, selected) =>
    selected.map(
      (values, id) =>
        Map({
          id: id,
          label: filters.get(id) ? filters.get(id).get('label') : id,
          values: values
        })
    )
);

function getValue(value, field) {
  switch (field) {
    case 'region':
      return value.split(/[DT]/)[0];
    case 'district':
      return value.substring(0, value.lastIndexOf('T'));
    default:
      return undefined;
  }
}

function toShow(selected, id, value) {

  if (selected.get(id).contains(value))
    return false;

  if (id === 'segment')
    return true;

  if (id === 'region') {
    return (
      selected.get('district').isEmpty() && selected.get('territory').isEmpty()
    )
  }

  if (id === 'district')
    return (
      selected.get('region').size < 2 && selected.get('territory').isEmpty()
      &&
      (
        selected.get('region').isEmpty()
        ||
        (!selected.get('region').isEmpty() && selected.get('region').contains(getValue(value, 'region')))
      )
    );

  if (id === 'territory')
    return (
      (selected.get('region').size < 2 && selected.get('district').size < 2)
      &&
      (
        (selected.get('district').isEmpty() && selected.get('region').isEmpty())
        ||
        (selected.get('district').size === 1 && selected.get('district').toList().get(0) === getValue(value, 'district'))
        ||
        (selected.get('district').isEmpty() && selected.get('region').size === 1 && selected.get('region').toList().get(0) === getValue(value, 'region'))
      )
    );
}
export const unselectedFiltersSelector = createSelector(
  filtersSelector,
  selectedSelector,
  (filters, selected) =>
    filters.map(
      filter =>
        Map({
          id: filter.get('id'),
          label: filter.get('label'),
          values: filter.get('values').filter(value => toShow(selected, filter.get('id'), value))
        })
    )
);

export const suggestionsSelector = createSelector(
  selectedFiltersSelector,
  unselectedFiltersSelector,
  searchInputValueSelector,
  (selectedFilters, unselectedFilters, searchInputValue) => {
    const filterText = searchInputValue.toLowerCase();
    let types = unselectedFilters
      .toList()
      .filter(
        filter =>
          filter.get('label').toLowerCase().includes(filterText) && !filter.get('values').isEmpty()
      ).map(
        filter =>
          Map({
            id: filter.get('id'),
            label: filter.get('label'),
            values: filter.get('values')
          })
      );
    let values = unselectedFilters
      .toList()
      .map(
        filter =>
          Map({
            id: filter.get('id'),
            label: filter.get('label'),
            values: filter.get('values').filter(value => value.toLowerCase().includes(filterText))
          })
      ).filter(
        filter =>
          !filter.get('values').isEmpty()
      );
    return {
      types: types.toJS(),
      values: values.toJS()
    };
  }
);

export const beginDateSelector = state => state.get('globalFilters').get('beginDate');

export const endDateSelector = state => state.get('globalFilters').get('endDate');

export const isGlobalFiltersLoadedSelector = state => state.get('globalFilters').get('isLoaded');

export const isFixeSelector = state => state.get('globalFilters').get('isFixe');

function filterUrlParams(globalFilters, beginDate, endDate) {
  const params = new URLSearchParams();
  if (beginDate)
    params.set('begin_time', moment(beginDate).format('YYYY-MM-DD'));
  if (endDate)
    params.set('end_time', moment(endDate).format('YYYY-MM-DD'));

  ['region', 'district', 'territory', 'segment'].forEach(key => {
    const filter = globalFilters.get(key);
    if (!filter)
      return;
    const values = filter.get('values').map(value => key === 'segment' ? value :
      value.substring(value.lastIndexOf(key.charAt(0).toUpperCase()) + 1)).join(',');
    if (values)
      params.set(key, values);
  });
  return params.toString();
}

export const globalFiltersUrlParamsSelector = createSelector(
  selectedFiltersSelector,
  beginDateSelector,
  endDateSelector,
  filterUrlParams
);

export const globalFiltersWithoutDatesUrlParamsSelector = createSelector(
  selectedFiltersSelector,
  globalFilters => filterUrlParams(globalFilters)
);

export const globalFiltersRoutingUrlParamsSelector = createSelector(
  selectedFiltersSelector,
  globalFilters => filterUrlParams(globalFilters, moment(), moment().add(15, 'days'))
);
